/**
 * Takes a value and returns `true` if value is `null` or `undefined`, otherwise returns `false`.
 *
 * ```ts
 * tt.isNil(null);
 * // => true
 *
 * tt.isNil(undefined);
 * // => true
 *
 * tt.isNil(0);
 * // => false
 * ```
 */
export function isNil(v: unknown) {
  return null == v;
}
